import { render, staticRenderFns } from "./op-purchase-oder-inbound.vue?vue&type=template&id=2705ee8f&scoped=true&"
import script from "./op-purchase-oder-inbound.vue?vue&type=script&lang=js&"
export * from "./op-purchase-oder-inbound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2705ee8f",
  null
  
)

export default component.exports